"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 12a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1v-2a1 1 0 011-1h14zM15 6a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1V7a1 1 0 011-1h14zM15 0a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h14z"];
//# sourceMappingURL=layout-three-rows.js.map